module.exports = __webpack_public_path__ + "static/media/dumbbellDefault.852d63b7.png";